module.exports = __webpack_public_path__ + "/images/logo-fr-aubert.164c1de.png";